import { useCallback, useEffect, useState } from "react";
import { brandsForCampaign, topBrands } from "./brands";
import placeholder from "assets/images/banners/empty.jpg";
import placeholder2x from "assets/images/banners/empty2x.jpg";

export const useGetHeroImage = () => {
  const [images, setImages] = useState({
    img: placeholder,
    retinaImg: placeholder2x,
    sources: []
  });
  const { pathname } = window.location;

  const getCustomPathname = useCallback(() => {
    const giftCardRoutePathname = pathname.match(/\/buy-(.*)-gift-cards/);
    return giftCardRoutePathname ? giftCardRoutePathname[1] : "";
  }, [pathname]);

  const getLogoClasses = useCallback(() => {
    const path = getCustomPathname();
    return path === "best-buy" ? "logo-img" : "logo-img circle";
  }, [getCustomPathname]);

  const getImagesSources = useCallback(async (path) => {
    if (brandsForCampaign.has(path)) {
      const { default: image } = await import(
        `assets/images/banners/EDB_${path}-gift-card_banner1x.jpg`
      );
      const { default: retinaImage } = await import(
        `assets/images/banners/EDB_${path}-gift-card_banner2x.jpg`
      );
      return { img: image, retinaImg: retinaImage };
    }

    const isTopBrand = topBrands.has(path);
    const cardName = isTopBrand ? path : "default";

    const { default: image } = await import(
      `assets/images/banners/${cardName}-gift-card_banner1x.jpg`
    );

    const { default: retinaImage } = await import(
      `assets/images/banners/${cardName}-gift-card_banner2x.jpg`
    );
    if (isTopBrand) {
      return {
        img: image,
        retinaImg: retinaImage
      };
    }
    const { default: webp } = await import(
      `assets/images/banners/${cardName}-gift-card_banner1x.webp`
    );
    const { default: retinaWebp } = await import(
      `assets/images/banners/${cardName}-gift-card_banner2x.webp`
    );
    const { default: avif } = await import(
      `assets/images/banners/${cardName}-gift-card_banner1x.avif`
    );
    const { default: retinaAvif } = await import(
      `assets/images/banners/${cardName}-gift-card_banner2x.avif`
    );
    const sources = [
      <source
        key="one"
        type="image/avif"
        srcSet={`${avif}, ${retinaAvif} 2x`}
      />,
      <source
        key="two"
        type="image/webp"
        srcSet={`${webp}, ${retinaWebp} 2x`}
      />
    ];
    return { img: image, retinaImg: retinaImage, sources };
  }, []);

  useEffect(() => {
    const getImages = async () => {
      const path = getCustomPathname();
      const images = await getImagesSources(path);
      setImages(images);
    };
    void getImages();
  }, [getCustomPathname, getImagesSources]);

  return {
    images,
    logoClasses: getLogoClasses()
  };
};
